export const predefinedAllowedSymbols = {
  numbers: /\d/,
};

export const predefinedForbiddenSymbols = {
  numbers: /\d/,
};
